import { render, staticRenderFns } from "./AddonsModal.vue?vue&type=template&id=595aff5d&scoped=true&"
import script from "./AddonsModal.vue?vue&type=script&lang=js&"
export * from "./AddonsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595aff5d",
  null
  
)

export default component.exports